<template>
    <div>
    <h3 class="is-size-3">Listado de actividades</h3>
        <p> <code>GET {{ host }}/api/economicActivities/{activityId?}</code> </p>
        <br>

        <h5 class="is-size-6">El endpoint tiene parámetros opcionales:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>activityId</strong>
                    <ul>
                        <li>Opcional (como parte del path)</li>
                        <li>Formato numérico (Ej. 0111013)</li>
                    </ul>
                </li>
                <li>
                    <strong>activityName</strong>
                    <ul>
                        <li>Opcional (como parámetro de consulta)</li>
                        <li>Formato texto (Ej. cultivo)</li>
                        <li>Se usa para búsqueda por coincidencia parcial (case-insensitive)</li>
                        <li>Ejemplo: <code>?activityName=alpiste</code></li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5> 
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>[{ 
            "activityId": "0100008",
            "activityName": "AGRICULTURA",
            "risk": "LOW",
            "isVulnerable": false,
            "isFpadm": false
        },
        { 
            "activityId": "0111013",
            "activityName": "CULTIVO DE ALPISTE",
            "risk": "LOW",
            "isVulnerable": false,
            "isFpadm": false
        }
        ...
        ]</code>
        </pre>
        <hr />
       
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>

</style>